import React, { useState, useEffect } from 'react';
import { supabase } from './supabase';

function Diary() {
  var [entries, setEntries] = useState([]);
  var [loading, setLoading] = useState(true);
  var [showForm, setShowForm] = useState(false);
  var [reading, setReading] = useState(null);
  var [form, setForm] = useState({
    title: '',
    content: '',
    author: 'aiden',
    date: new Date().toISOString().split('T')[0]
  });

  useEffect(function() {
    fetchEntries();
  }, []);

  var fetchEntries = async function() {
    var result = await supabase
      .from('diary')
      .select('*')
      .order('date', { ascending: false });
    if (result.error) {
      console.error('Failed to load diary:', result.error);
    } else {
      setEntries(result.data || []);
    }
    setLoading(false);
  };

  var addEntry = async function() {
    if (form.title.trim() === '' || form.content.trim() === '') return;
    var result = await supabase
      .from('diary')
      .insert([{
        title: form.title,
        content: form.content,
        author: form.author,
        date: form.date
      }])
      .select();
    if (result.data) {
      setEntries(function(prev) { return [result.data[0]].concat(prev); });
      setForm({ title: '', content: '', author: 'aiden', date: new Date().toISOString().split('T')[0] });
      setShowForm(false);
    }
  };

  var formatDate = function(dateStr) {
    if (!dateStr) return '';
    if (typeof dateStr === 'string' && dateStr.match(/^\d{4}-\d{2}-\d{2}$/)) {
      var p = dateStr.split('-');
      return p[0] + ' \u5E74 ' + p[1] + ' \u6708 ' + p[2] + ' \u65E5';
    }
    var d = new Date(dateStr);
    var y = d.getFullYear();
    var m = (d.getMonth() + 1).toString().padStart(2, '0');
    var day = d.getDate().toString().padStart(2, '0');
    var h = d.getHours().toString().padStart(2, '0');
    var min = d.getMinutes().toString().padStart(2, '0');
    return y + ' \u5E74 ' + m + ' \u6708 ' + day + ' \u65E5 ' + h + ':' + min;
  };

  if (reading) {
    return (
      <div className="diary">
        <div className="diary-reading">
          <button className="diary-back" onClick={function() { setReading(null); }}>
            ‹ 返回
          </button>
          <div className="diary-full">
            <div className="diary-full-title">{reading.title}</div>
            <div className="diary-full-meta">
              <span className={'diary-full-author ' + reading.author}>
                {reading.author === 'aiden' ? '林晏的日记' : '知枝的日记'}
              </span>
              <span className="diary-full-sep">|</span>
              <span className="diary-full-date">{formatDate(reading.date)}</span>
            </div>
            <div className="diary-full-body">{reading.content}</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="diary">
      <div className="diary-header-new">
        <div className="diary-title-new">日记本</div>
        <button className="diary-add-btn-new" onClick={function() { setShowForm(!showForm); }}>
          {showForm ? '取消' : '+ 写日记'}
        </button>
      </div>

      {showForm && (
        <div className="diary-form-new">
          <input
            className="diary-input-new"
            placeholder="标题"
            value={form.title}
            onChange={function(e) { setForm(Object.assign({}, form, { title: e.target.value })); }}
          />
          <textarea
            className="diary-textarea-new"
            placeholder="写点什么..."
            value={form.content}
            onChange={function(e) { setForm(Object.assign({}, form, { content: e.target.value })); }}
            rows={8}
          />
          <div className="diary-form-row-new">
            <input
              className="diary-date-new"
              type="date"
              value={form.date}
              onChange={function(e) { setForm(Object.assign({}, form, { date: e.target.value })); }}
            />
            <select
              className="diary-select-new"
              value={form.author}
              onChange={function(e) { setForm(Object.assign({}, form, { author: e.target.value })); }}
            >
              <option value="aiden">林晏</option>
              <option value="zhizhi">知枝</option>
            </select>
          </div>
          <button className="diary-submit-new" onClick={addEntry}>保存</button>
        </div>
      )}

      <div className="diary-list-new">
        {loading ? (
          <div className="diary-empty-new">加载中...</div>
        ) : entries.length === 0 ? (
          <div className="diary-empty-new">还没有日记</div>
        ) : (
          entries.map(function(entry) {
            return (
              <div key={entry.id} className="diary-card-new" onClick={function() { setReading(entry); }}>
                <div className="diary-card-top">
                  <span className={'diary-card-author-new ' + entry.author}>
                    {entry.author === 'aiden' ? '林晏' : '知枝'}
                  </span>
                  <span className="diary-card-date-new">{formatDate(entry.date)}</span>
                </div>
                <div className="diary-card-title-new">{entry.title}</div>
                <div className="diary-card-preview-new">
                  {entry.content.length > 80 ? entry.content.substring(0, 80) + '...' : entry.content}
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}

export default Diary;
